import(/* webpackMode: "eager", webpackExports: ["HeadSection"] */ "/app/app/(site)/forhandler/[slug]/components/headSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContent"] */ "/app/app/(site)/forhandler/[slug]/components/pageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FiltersProvider"] */ "/app/components/filters/filtersProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageWrapper"] */ "/app/components/styled-common/pageWrapper.ts");
;
import(/* webpackMode: "eager", webpackExports: ["DepartmentThemeWrapper"] */ "/app/design-system/DepartmentThemeWrapper.tsx");
